import { createAction, props } from '@ngrx/store';
import { GroundControlPoint } from '../../models/geoasset.model';

export const loadingGcpAssets = createAction('[Geo Assets] loading gcp assets');

export const loadingGcpAssetsSuccess = createAction(
  '[Geo Assets] loading GCP Assets data success',
  props<{ groundControlPoints: GroundControlPoint[] }>(),
);

export const loadingGcpAssetsError = createAction(
  '[Geo Assets] loading GCP Assets data error',
  props<{ error: any }>(),
);

export const createGcpAssets = createAction(
  '[Geo Assets] creating GCP Assets',
  props<{ groundControlPoints: GroundControlPoint[] }>(),
);

export const creatingGcpAssetsSuccess = createAction(
  '[Geo Assets] creating GCP Assets success',
  props<{ groundControlPoints: GroundControlPoint[] }>(),
);

export const creatingGcpAssetsError = createAction(
  '[Geo Assets] creating GCP Assets error',
  props<{ error: any }>(),
);

export const deleteGcp = createAction(
  '[Geo Assets] delete gcp',
  props<{ gcpId: string }>(),
);
export const deleteGcpSuccess = createAction(
  '[Geo Assets] delete gcp success',
  props<{ gcpId: string }>(),
);
export const deleteGcpError = createAction(
  '[Geo Assets] delete gcp error',
  props<{ error: any }>(),
);

export const editGcp = createAction(
  '[Geo Assets] edit gcp',
  props<{ id: string; changes: Partial<GroundControlPoint> }>(),
);

export const editGcpSuccess = createAction(
  '[Geo Assets] edit gcp success',
  props<{ groundControlPoint: GroundControlPoint }>(),
);
export const editGcpError = createAction(
  '[Geo Assets] edit gcp error',
  props<{ error: any }>(),
);
